export const WEEKEND_OFFSETS: string[] = ["Next Working day", "Place holder", "Place holder"];
